// 路由规则条件的前端校验，与服务端一致：MNC 保留字符串身份（D132）。
import { validMcc, validMnc } from "@/app/form";
import type { RouteConditions } from "@/app/routing";

/** 验证 MCC/MNC，MNC 必须保留字符串身份。 */
export function routeConditionError(m: Pick<RouteConditions, "mcc" | "mnc">): string | null {
  if (m.mcc && !validMcc(m.mcc)) return "MCC 是三位数字。";
  if (m.mnc && !validMnc(m.mnc)) return "MNC 是两到三位数字。";
  if (m.mnc && !m.mcc) return "给了 MNC 就要给 MCC。";
  return null;
}
